export const GATEWAY_WALLET_DIRECTION = ['gateway_to_wallet', 'wallet_to_gateway'];
